export { DETAILS_DIRECTIVE_NAME, COMPONENTS_MODULE_NAME } from './operator.components.module'